const pricingRules = [
  {
    quantity: "Pallet (1000 lbs.)",
    destinations: ["Oregon", "Washington", "California", "Nevada"],
    stoneSize: [".75 in. - 1.5 in.", "1.5 in. - 2.5 in.", "3 in. - 5 in."],
    shippingOption: ["Commercial", "Residential"],
    price: "$795.00",
    shopifyTitle:
      "Polished Black Mexican Beach Pebbles (By the Pallet) | Quality Stone | Pallet (1000 lbs.) | OR, WA, CA, NV",
  },
  {
    quantity: "Pallet (1000 lbs.)",
    destinations: [
      "Alabama",
      "Alaska",
      "Arizona",
      "Arkansas",
      "Colorado",
      "Connecticut",
      "Delaware",
      "Florida",
      "Georgia",
      "Hawaii",
      "Idaho",
      "Illinois",
      "Indiana",
      "Iowa",
      "Kansas",
      "Kentucky",
      "Louisiana",
      "Maine",
      "Maryland",
      "Massachusetts",
      "Michigan",
      "Minnesota",
      "Mississippi",
      "Missouri",
      "Montana",
      "Nebraska",
      "New Hampshire",
      "New Jersey",
      "New Mexico",
      "New York",
      "North Carolina",
      "North Dakota",
      "Ohio",
      "Oklahoma",
      "Pennsylvania",
      "Rhode Island",
      "South Carolina",
      "South Dakota",
      "Tennessee",
      "Texas",
      "Utah",
      "Vermont",
      "Virginia",
      "West Virginia",
      "Wisconsin",
      "Wyoming",
    ],
    stoneSize: [".75 in. - 1.5 in.", "1.5 in. - 2.5 in.", "3 in. - 5 in."],
    shippingOption: ["Commercial", "Residential"],
    price: "Not available",
    error:
      "Unavailable (1,000 lbs. Pallets are only available in California, Nevada, Washington, and Oregon. Limit 1 pallet.)",
  },
  {
    quantity: "Full Pallet (2450 lbs.)",
    destinations: [
      "California",
      "Idaho",
      "Nevada",
      "Oregon",
      "Utah",
      "Washington",
    ],
    stoneSize: [".75 in. - 1.5 in.", "1.5 in. - 2.5 in.", "3 in. - 5 in."],
    shippingOption: ["Commercial"],
    price: "$2,099.00",
    shopifyTitle:
      "Polished Black Mexican Beach Pebbles (By the Pallet) | Quality Stone | Full Pallet (2450 lbs.) | Commercial | CA, ID, NV, OR, UT, WA",
  },
  {
    quantity: "Full Pallet (2450 lbs.)",
    destinations: [
      "California",
      "Idaho",
      "Nevada",
      "Oregon",
      "Utah",
      "Washington",
    ],
    stoneSize: [".75 in. - 1.5 in.", "1.5 in. - 2.5 in.", "3 in. - 5 in."],
    shippingOption: ["Residential"],
    price: "$2,199.00",
    shopifyTitle:
      "Polished Black Mexican Beach Pebbles (By the Pallet) | Quality Stone | Full Pallet (2450 lbs.) | Residential | CA, ID, NV, OR, UT, WA",
  },
  {
    quantity: "Full Pallet (2450 lbs.)",
    destinations: [
      "Arizona",
      "Colorado",
      "Iowa",
      "Kansas",
      "Minnesota",
      "Montana",
      "Nebraska",
      "New Mexico",
      "North Dakota",
      "South Dakota",
      "Wyoming",
    ],
    stoneSize: [".75 in. - 1.5 in.", "1.5 in. - 2.5 in.", "3 in. - 5 in."],
    shippingOption: ["Commercial"],
    price: "$2,199.00",
    shopifyTitle:
      "Polished Black Mexican Beach Pebbles (By the Pallet) | Quality Stone | Full Pallet (2450 lbs.) | Commercial | AZ, CO, IA, KS, MN, MT, NE, NM, ND, SD, WY",
  },
  {
    quantity: "Full Pallet (2450 lbs.)",
    destinations: [
      "Arizona",
      "Colorado",
      "Iowa",
      "Kansas",
      "Minnesota",
      "Montana",
      "Nebraska",
      "New Mexico",
      "North Dakota",
      "South Dakota",
      "Wyoming",
    ],
    stoneSize: [".75 in. - 1.5 in.", "1.5 in. - 2.5 in.", "3 in. - 5 in."],
    shippingOption: ["Residential"],
    price: "$2,299.00",
    shopifyTitle:
      "Polished Black Mexican Beach Pebbles (By the Pallet) | Quality Stone | Full Pallet (2450 lbs.) | Residential | AZ, CO, IA, KS, MN, MT, NE, NM, ND, SD, WY",
  },
  {
    quantity: "Full Pallet (2450 lbs.)",
    destinations: [
      "Alabama",
      "Arkansas",
      "Illinois",
      "Indiana",
      "Kentucky",
      "Louisiana",
      "Michigan",
      "Mississippi",
      "Missouri",
      "Ohio",
      "Oklahoma",
      "Tennessee",
      "Texas",
      "Wisconsin",
    ],
    stoneSize: [".75 in. - 1.5 in.", "1.5 in. - 2.5 in.", "3 in. - 5 in."],
    shippingOption: ["Commercial"],
    price: "$2,395.00",
    shopifyTitle:
      "Polished Black Mexican Beach Pebbles (By the Pallet) | Quality Stone | Full Pallet (2450 lbs.) | Commercial | AL, AR, IL, IN, KY, LA, MI, MS, MO, OH, OK, TN, TX, WI",
  },
  {
    quantity: "Full Pallet (2450 lbs.)",
    destinations: [
      "Alabama",
      "Arkansas",
      "Illinois",
      "Indiana",
      "Kentucky",
      "Louisiana",
      "Michigan",
      "Mississippi",
      "Missouri",
      "Ohio",
      "Oklahoma",
      "Tennessee",
      "Texas",
      "Wisconsin",
    ],
    stoneSize: [".75 in. - 1.5 in.", "1.5 in. - 2.5 in.", "3 in. - 5 in."],
    shippingOption: ["Residential"],
    price: "$2,495.00",
    shopifyTitle:
      "Polished Black Mexican Beach Pebbles (By the Pallet) | Quality Stone | Full Pallet (2450 lbs.) | Residential | AL, AR, IL, IN, KY, LA, MI, MS, MO, OH, OK, TN, TX, WI",
  },
  {
    quantity: "Full Pallet (2450 lbs.)",
    destinations: [
      "Connecticut",
      "Delaware",
      "Georgia",
      "Maryland",
      "Massachusetts",
      "New Jersey",
      "New York",
      "North Carolina",
      "Pennsylvania",
      "Rhode Island",
      "South Carolina",
      "Virginia",
      "West Virginia",
    ],
    stoneSize: [".75 in. - 1.5 in.", "1.5 in. - 2.5 in.", "3 in. - 5 in."],
    shippingOption: ["Commercial"],
    price: "$2,499.00",
    shopifyTitle:
      "Polished Black Mexican Beach Pebbles (By the Pallet) | Quality Stone | Full Pallet (2450 lbs.) | Commercial | CT, DE, GA, MD, MA, NJ, NY, NC, PA, RI, SC, VA, WV",
  },
  {
    quantity: "Full Pallet (2450 lbs.)",
    destinations: [
      "Connecticut",
      "Delaware",
      "Georgia",
      "Maryland",
      "Massachusetts",
      "New Jersey",
      "New York",
      "North Carolina",
      "Pennsylvania",
      "Rhode Island",
      "South Carolina",
      "Virginia",
      "West Virginia",
    ],
    stoneSize: [".75 in. - 1.5 in.", "1.5 in. - 2.5 in.", "3 in. - 5 in."],
    shippingOption: ["Residential"],
    price: "$2,599.00",
    shopifyTitle:
      "Polished Black Mexican Beach Pebbles (By the Pallet) | Quality Stone | Full Pallet (2450 lbs.) | Residential | CT, DE, GA, MD, MA, NJ, NY, NC, PA, RI, SC, VA, WV",
  },
  {
    quantity: "Full Pallet (2450 lbs.)",
    destinations: ["Florida", "Maine", "New Hampshire", "Vermont"],
    stoneSize: [".75 in. - 1.5 in.", "1.5 in. - 2.5 in.", "3 in. - 5 in."],
    shippingOption: ["Commercial"],
    price: "$2,599.00",
    shopifyTitle:
      "Polished Black Mexican Beach Pebbles (By the Pallet) | Quality Stone | Full Pallet (2450 lbs.) | Commercial | FL, ME, NH, VT",
  },
  {
    quantity: "Full Pallet (2450 lbs.)",
    destinations: ["Florida", "Maine", "New Hampshire", "Vermont"],
    stoneSize: [".75 in. - 1.5 in.", "1.5 in. - 2.5 in.", "3 in. - 5 in."],
    shippingOption: ["Residential"],
    price: "$2,699.00",
    shopifyTitle:
      "Polished Black Mexican Beach Pebbles (By the Pallet) | Quality Stone | Full Pallet (2450 lbs.) | Residential | FL, ME, NH, VT",
  },
];

// main process
initCustomPricing("$795.00");
